export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-github-6f562275c8d60051d75eda3baac385f3.svg";